// extracted by mini-css-extract-plugin
module.exports = {"container":"FotoUsuario_container__3u3lz"};